module.exports = __webpack_public_path__ + "app/principal/widgets/order-config/order-section-2PIllmFM.html";